import React, { useCallback } from 'react';
import ContentViewTypes from '../../../../model/ContentViewTypes';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import SelectBox from '../base/SelectBox';
import useT from '../../utils/Translations/useT';
import styles from './ContentViewSelector.scss';
const ContentViewSelector = ({ onChange, value, ...props }) => {
    const t = useT();
    const { options } = useEnumerableModel(ContentViewTypes);
    const handleStatusChange = useCallback(value => onChange && onChange(value), [
        onChange,
    ]);
    return (<SelectBox isFilterBar menuClassName={styles.menu} options={options} title={t('View')} value={value} onChange={handleStatusChange} {...props}/>);
};
export default ContentViewSelector;
